// @flow

import React from "react";
import SvgIcon, { type SvgIconProps } from "../SvgIcon";

const Measure = (props: SvgIconProps) => (
    <SvgIcon {...props}>
        <svg viewBox="0 0 12 12">
            <g>
                <path d="M12,7.87H10.35L9.22,9.57A.62.62,0,0,1,9,9.75a.66.66,0,0,1-.93-.18L4.67,4.41,2.55,7.57a.65.65,0,0,1-.55.3H0V6.13H1.65l2.46-3.7a.62.62,0,0,1,.18-.18.66.66,0,0,1,.93.18L8.67,7.59l.78-1.16a.65.65,0,0,1,.55-.3h2Z" />
                <polyline points="0 6.13 0 7.87 0 7.87" />
            </g>
        </svg>
    </SvgIcon>
);

export default Measure;
